import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from '../../../services/subscription.service';
import { TokenService } from '../../../services/token.service';
import { UnsubscribeResponse } from '../../../interfaces/subscription.interface';

type UnsubscribeStatus = 'confirm' | 'loading' | 'unsubscribed' | 'error';

@Component({
  selector: 'app-unsubscribe',
  styleUrls: ['./unsubscribe.component.scss'],
  templateUrl: './unsubscribe.component.html',
})
export class UnsubscribeComponent implements OnInit {
  public status: UnsubscribeStatus = 'confirm';
  // token extracted from URL so template can link to resubscribe
  public token: string | null = null;

  constructor(
    private readonly subscriptionService: SubscriptionService,
    private readonly tokenService: TokenService,
    private readonly route: ActivatedRoute,
  ) { }

  public ngOnInit(): void {
    // Opening the link from an email must not unsubscribe on its own, so we only
    // read the token here and let the confirmation screen render.
    const token = this.tokenService.getTokenFromLocation('token');
    // expose token so templates can link to resubscribe with it
    this.token = token;

    if (!token) {
      this.status = 'error';
      return;
    }

    // The resubscribe page links here with confirmed=true; emails never do, so the
    // user is only asked to confirm when arriving from an email.
    if (this.route.snapshot.queryParamMap.get('confirmed') === 'true') {
      this.unsubscribe();
    }
  }

  // Fires the unsubscribe ONLY on explicit user click, exactly once per submit.
  public onConfirm(): void {
    if (this.status === 'confirm') {
      this.unsubscribe();
    }
  }

  private unsubscribe(): void {
    this.status = 'loading';
    this.subscriptionService.unsubscribe(this.token as string, false).subscribe({
      error: () => {
        this.status = 'error';
      },
      next: (response: UnsubscribeResponse) => {
        this.handleResponse(response);
      },
    });
  }

  private handleResponse(response: UnsubscribeResponse | null): void {
    if (!response || !response.success) {
      this.status = 'error';
    } else {
      this.status = 'unsubscribed';
    }
  }
}

